import React from "react";
import { startCase } from "lodash";
import { Box, Tab, Tabs } from "@mui/material";

import { BillSettings } from "./BillSettings";
import Panel from "../../../../components/Panel";
import { GlobalSettings } from "../GlobalSettings/GlobalSettings";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";
import { BillLocalSettings } from "./BillLocalSettings";

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
}

const TABS = {
  BILL_SETTINGS: "billSettings",
  LOCALISED_BILL_SETTINGS: "billLocalSettings",
  COMMON_SETTINGS: "globalSettings"
};

// eslint-disable-next-line import/prefer-default-export
export const BillSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true
}: Props): React.ReactNode => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const [selectedTab, setSelectedTab] = React.useState(TABS.BILL_SETTINGS);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel
          onClose={() => setOpen(false)}
          title="Billing Settings"
          contentStyle={{ py: 0, height: "calc(100vh - 50px)" }}
        >
          <Box sx={{ height: "100%", borderLeft: 1, borderRight: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedTab}
              onChange={(_, newValue) => setSelectedTab(newValue)}
              sx={{
                height: "50px",
                borderBottom: 1,
                borderColor: "divider"
              }}
            >
              <Tab label={startCase(TABS.BILL_SETTINGS)} value={TABS.BILL_SETTINGS} />
              <Tab
                label={startCase(TABS.LOCALISED_BILL_SETTINGS)}
                value={TABS.LOCALISED_BILL_SETTINGS}
              />
              <Tab label={startCase(TABS.COMMON_SETTINGS)} value={TABS.COMMON_SETTINGS} />
            </Tabs>

            <Box
              sx={{
                p: 2,
                height: "calc(100vh - 100px)",
                overflow: "auto"
              }}
            >
              {selectedTab === TABS.BILL_SETTINGS && <BillSettings />}
              {selectedTab === TABS.LOCALISED_BILL_SETTINGS && <BillLocalSettings />}
              {selectedTab === TABS.COMMON_SETTINGS && <GlobalSettings />}
            </Box>
          </Box>
        </Panel>
      )}
    </>
  );
};
